import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { getPeriodeRpjmd_newSakatoplan_act } from '../../../redux/ducks/newsakatoplan/actions'


const PeriodeRpjmdSelector = ({ periodeState, getPeriodeRpjmd, onChangeAction = null, selectedValue = null }) => {
    const [listPeriode, setListPeriode] = React.useState([{ value: "", label: "Pilih Periode" }])
    React.useEffect(() => {
        getPeriodeRpjmd()
    },[])
    React.useEffect(() => {
        if(periodeState.data.length > 0) {
            let list = []
            list.push({ value: "", label: "Pilih Periode" })
            periodeState.data.map((item) => {
                list.push({
                    value: item.id,
                    label: item.name,
                    ...item
                })
            })
            setListPeriode(list)
        }
    },[periodeState])

    return (
        <>
            <label htmlFor="" className="font-bold italic text-xs">
                Periode
            </label>
            <select
                value={selectedValue}
                className="bg-gray-50 border border-gray-300 text-gray-800 sm:text-md text-sm font-bold rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-1.5 placeholder:text-gray-900"
                onChange={onChangeAction}
            >
                {listPeriode.map((item) => (
                    <option value={item.value}>{item.label}</option>
                ))}
            </select>
        </>
    )
}

const mapStateToProps = (state) => ({
    periodeState: state.newsakatoplanState.periodeRpjmd
})

const mapDispatchToProps = {
    getPeriodeRpjmd: getPeriodeRpjmd_newSakatoplan_act
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(withConnect, React.memo)(PeriodeRpjmdSelector)